export const translation = {
    methods: {
    /**
     * Translate the given key.
     */
        __(key, replace = {}) {
            let translated = this.$page.props.translations.strings[key]
                ? this.$page.props.translations.strings[key]
                : key;

            Object.keys(replace).forEach((placeholder) => {
                translated = translated.replace(`:${placeholder}`, replace[placeholder]);
            });

            return translated;
        },
    },
};
